var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-view',{attrs:{"size":"small","columns":_vm.columns,"data":_vm.list,"loading":_vm.loading,"pagination":_vm.pageData,"showSizeChanger":false,"showQuickJumper":false,"scroll":_vm.SCROLL},on:{"handlePagination":_vm.handlePagination},scopedSlots:_vm._u([{key:"insurance",fn:function(ref){
var tableRow = ref.tableRow;
return [_c('span',[_vm._v(_vm._s(_vm._f("formatAmount")(tableRow.insurance)))])]}},{key:"netAr",fn:function(ref){
var tableRow = ref.tableRow;
return [_c('span',[_vm._v(_vm._s(_vm._f("formatAmount")(tableRow.netAr)))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }